import request from '@/utils/request'

/**
 * 获取购物车列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listStoreCart(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeCart.listStoreCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新购物车商品
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function updateStoreCart(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeCart.updateStoreCart',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除购物车商品
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deleteStoreCart(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeCart.deleteStoreCart',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}